import { render, staticRenderFns } from "./LostAccessModal.vue?vue&type=template&id=68c7d41e&"
import script from "./LostAccessModal.vue?vue&type=script&lang=ts&"
export * from "./LostAccessModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports